import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return(
    <Route
      {...rest}
      render={props => {
        if (localStorage.getItem('jwt')) {
          return <Component {...props} />
        }
        return <Redirect to='/signup' />
      }}
    />
  )
}
export default PrivateRoute